const validate = values => {
  const errors = {}

  if (values && values.survey_form?.questions?.questionsList) {
    values.survey_form?.questions?.questionsList.forEach((question, index) => {
      if (!question.question) {
        errors.survey_form = {
          ...errors.survey_form,
          questions: {
            ...errors.survey_form?.questions,
            questionsList: {
              ...errors.survey_form?.questions?.questionsList,
              [`${index}`]: {
                ...errors.survey_form?.questions?.questionsList[`${index}`],
                question: "This question is required",
              },
            },
          },
        }
      }
      if (
        question.answerType === "1" &&
        question.answers.filter(
          answer => answer?.answer && answer?.answer.trim()
        ).length < 2
      ) {
        errors.survey_form = {
          ...errors.survey_form,
          questions: {
            ...errors.survey_form?.questions,
            questionsList: {
              ...errors.survey_form?.questions?.questionsList,
              [`${index}`]: {
                ...errors.survey_form?.questions?.questionsList[`${index}`],
                answers: {
                  _error: "You have to add at least 2 valid answers.",
                },
              },
            },
          },
        }
      }
    })
  }

  if (
    values.survey_form?.questions?.retake &&
    !values.survey_form?.questions?.retakeText
  ) {
    errors.survey_form = {
      ...errors.survey_form,
      questions: {
        ...errors.survey_form?.questions,
        retakeText: "The retake button text is required",
      },
    }
  }

  if (!values.survey_form?.questions?.name) {
    errors.survey_form = {
      ...errors.survey_form,
      questions: {
        ...errors.survey_form?.questions,
        name: "The name is required!",
      },
    }
  }

  return errors
}

export default validate
